import { render, staticRenderFns } from "./SelectGlobalEvent.vue?vue&type=template&id=13d17db1&"
import script from "./SelectGlobalEvent.vue?vue&type=script&lang=ts&"
export * from "./SelectGlobalEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports